//AUTH
export const GET_USER_DATA = "GET_USER_DATA";
export const GET_USER_DATA_SUCCESS = "GET_USER_DATA_SUCCESS";
export const GET_USER_DATA_ERROR = "GET_USER_DATA_ERROR";
export const LOGOUT_USER = "LOGOUT_USER";
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS";
export const LOGOUT_USER_ERROR = "LOGOUT_USER_ERROR";

//PARAMS
export const LIST_PARAMS = "LIST_PARAMS";
export const LIST_PARAMS_SUCCESS = "LIST_PARAMS_SUCCESS";
export const LIST_PARAMS_ERROR = "LIST_PARAMS_ERROR";

//PAYMENT LOTS
export const LIST_PAYMENT_LOTS = "LIST_PAYMENT_LOTS";
export const LIST_PAYMENT_LOTS_SUCCESS = "LIST_PAYMENT_LOTS_SUCCESS";
export const LIST_PAYMENT_LOTS_ERROR = "LIST_PAYMENT_LOTS_ERROR";
export const BRANCH_PAYMENT_LOT = "BRANCH_PAYMENT_LOT";
export const BRANCH_PAYMENT_LOT_SUCCESS = "BRANCH_PAYMENT_LOT_SUCCESS";
export const BRANCH_PAYMENT_LOT_ERROR = "BRANCH_PAYMENT_LOT_ERROR";